/**
 * Der Weg der erzeugten Datei nach DATEV, Schritt fuer Schritt und mit der
 * Fundstelle in der DATEV-Hilfe. Steht im Exportfenster und in der Hilfe.
 */
export function DatevAnleitung({ format }: { format: 'camt053' | 'mt940' }) {
  if (format === 'mt940') {
    return (
      <ol className="anleitung">
        <li>Im Mandantenbestand <b>Stammdaten | Banken</b>, die Bankverbindung öffnen, <b>Einstellungen Bankkontoumsätze</b>.</li>
        <li>Als Quelle <b>Nicht aufgeführtes Programm</b>, Dateiformat <b>MT940-SWIFT</b>, als Pfad den Ordner mit der .sta-Datei.</li>
        <li>Für ältere Zeiträume das Feld <b>Neue Kontoumsätze übernehmen ab</b> setzen.</li>
        <li>Danach wie gewohnt über <b>Belege buchen</b> die Buchungsvorschläge erzeugen.</li>
        <li className="leiser">Quelle: DATEV-Hilfe Dok.-Nr. 1036444 und 9226962.</li>
      </ol>
    )
  }
  return (
    <ol className="anleitung">
      <li><b>Einmal je Konto:</b> im Mandantenbestand <b>Stammdaten | Banken</b>, die Bankverbindung öffnen, Registerkarte <b>Zusatzangaben Rechnungswesen</b>, <b>Rechnungswesen Bank</b> aktivieren, FIBU-Konto eintragen, unter <b>Einstellungen Bankkontoumsätze</b> als Quelle <b>DATEV Rechenzentrum</b> wählen.</li>
      <li><b>Bestand | Daten senden | Bankverbindungen an RZ-Bankinfo</b>. Bis zur Freischaltung können bis zu 30 Minuten vergehen. Eine Teilnahmeerklärung der Bank ist dafür nicht nötig.</li>
      <li><b>Bestand | Daten holen | Übersicht Bankverbindungen RZ</b>, das Konto markieren, <b>Kontenverwaltung</b>, dann <b>Umsätze importieren</b> und die Datei oder das ZIP hineinziehen, <b>Importieren</b>.</li>
      <li><b>Erfassen | Belege buchen</b>, <b>Buchungsvorschläge bearbeiten</b>, die Bankverbindung wählen. Die Umsätze stehen als Buchungsvorschläge bereit.</li>
      <li className="leiser">Voraussetzung ist das Recht „DATEV Payment | Kontenverwaltung“. Das Speichern von Bankverbindungen im Rechenzentrum kostet bei DATEV eine monatliche Gebühr. Quelle: DATEV-Hilfe Dok.-Nr. 1047946.</li>
    </ol>
  )
}
